/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Label_Waiting_OwnerInputs */

const en_wb_label_waiting_owner = /** @type {(inputs: Wb_Label_Waiting_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting for the order owner`)
};

const lv_wb_label_waiting_owner = /** @type {(inputs: Wb_Label_Waiting_OwnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaida pasūtījuma atbildīgo`)
};

/**
* | output |
* | --- |
* | "Waiting for the order owner" |
*
* @param {Wb_Label_Waiting_OwnerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_label_waiting_owner = /** @type {((inputs?: Wb_Label_Waiting_OwnerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Label_Waiting_OwnerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_label_waiting_owner(inputs)
	return en_wb_label_waiting_owner(inputs)
});